// ECRIT A LA MAIN, icone du fondateur (voir `./index.ts`).
import { createCustomIcon } from './create-custom-icon.js';

/** Supprimer : la corbeille a couvercle. Source `delete.svg`. */
export const IconDelete = createCustomIcon(
  'IconDelete',
  '0 0 239.01 239.04',
  <>
    <path
      fill="currentColor"
      d="M216.62,239.04H22.38V84.93s-22.38-.26-22.38-.26v-34.85h62.74C66.66,20.78,91.46-.19,119.98,0c28.11.19,52.46,21.09,56.2,49.81l62.82.02v34.82s-22.37.09-22.37.09v154.29ZM140.67,49.82c-3.79-9.19-12.2-15.15-21.63-14.88s-17.3,5.82-20.56,14.89h42.19ZM191.67,84.68H47.33v129.46h144.34V84.68Z"
    />
    <rect fill="currentColor" x="77.15" y="112.04" width="24.95" height="69.76" />
    <rect fill="currentColor" x="136.9" y="112.04" width="24.95" height="69.76" />
  </>,
);
